<template>
  <div id="contents">
    <ul class="list-images">
      <li v-for="(item, index) in imagesContent" :key="index" @click="onClickPopupConetnt(item)">
        <div class="image-content" :style="{'background-image':'url('+item.image+')'}">
          <div :class="{'approve':item.status == true, 'disapprove':item.status == false}">
            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" v-if="item.status == true">
              <path id="Path_11414" data-name="Path 11414" d="M753.7,327.178a17.5,17.5,0,1,1,17.5-17.5A17.52,17.52,0,0,1,753.7,327.178Zm0-33.388a15.888,15.888,0,1,0,15.888,15.888A15.906,15.906,0,0,0,753.7,293.79Zm0,9.481a15.685,15.685,0,0,0-12.657,6.406,15.707,15.707,0,0,0,25.315,0A15.686,15.686,0,0,0,753.7,303.271Zm0,11.246a4.84,4.84,0,1,1,4.84-4.84A4.84,4.84,0,0,1,753.7,314.518Zm0-8a3.164,3.164,0,1,0,3.164,3.164A3.163,3.163,0,0,0,753.7,306.514ZM755,308.5a.694.694,0,1,1,.694-.694A.694.694,0,0,1,755,308.5Z" transform="translate(-736.196 -292.178)" fill="#fff"/>
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35.001" viewBox="0 0 35 35.001" v-if="item.status == false">
              <path id="Path_11366" data-name="Path 11366" d="M670.31,292.178a17.5,17.5,0,1,0,17.5,17.5A17.52,17.52,0,0,0,670.31,292.178Zm15.888,17.5a15.815,15.815,0,0,1-3.728,10.211l-5.358-5.358a15.773,15.773,0,0,0,5.855-4.853,15.7,15.7,0,0,0-16.609-5.9l-6.259-6.259a15.877,15.877,0,0,1,26.1,12.16Zm-20.106-2.368,1.258,1.258a3.157,3.157,0,0,0,4.07,4.07l1.258,1.258a4.837,4.837,0,0,1-6.587-6.587Zm4.831.5a.694.694,0,1,1,.694.694A.694.694,0,0,1,670.923,307.809Zm2.373,2.906a3.158,3.158,0,0,0-4.024-4.024L668,305.423a4.841,4.841,0,0,1,6.562,6.562Zm-18.874-1.038a15.815,15.815,0,0,1,3.774-10.264l5.379,5.378a15.785,15.785,0,0,0-5.922,4.886,15.7,15.7,0,0,0,16.687,5.879l6.235,6.235a15.876,15.876,0,0,1-26.152-12.114Z" transform="translate(-652.81 -292.178)" fill="#fff"/>
            </svg>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import image01 from '@/assets/images/images01.jpg'
import image02 from '@/assets/images/images02.jpg'
import image03 from '@/assets/images/images03.jpg'
import image04 from '@/assets/images/images04.jpg'
import image05 from '@/assets/images/images05.jpg'
import image06 from '@/assets/images/images06.jpg'
import ContentPopup from '@/services/ContentPopup.js'
export default {
  name: 'contents',
  data() {
    return {
      imagesContent : [
        {name:'images01', image:image01, status: false},
        {name:'images02', image:image02, status: true},
        {name:'images03', image:image03, status: true},
        {name:'images04', image:image04, status: true},
        {name:'images05', image:image05, status: true},
        {name:'images06', image:image06, status: false},
      ]
    }
  },
  methods: {
    onClickPopupConetnt(item) {
      ContentPopup.open(item);
    }
  }
}
</script>

<style lang="scss" scoped>
  #contents {

    @media only screen and (min-width: 1920px) {
      padding: 80px 50px;
    }

    .list-images {
      list-style: none;
      padding: 0;
      display: flex;
      flex-wrap: wrap;
      width: 100%;

      li {
        cursor: pointer;
        height: 18.8vh;
        width: 16.66%;
        padding: 1px;
        .image-content {
          position: relative;
          height: 100%;
          width: 100%;
          background-position: center;
          background-size: cover;

          div {
            position: absolute;
            bottom: 0;
            height: 50%;
            width: 100%;

            &.approve {
              background-image: linear-gradient(transparent, var(--primary-color));
            }

            &.disapprove {
              background-image: linear-gradient(transparent, #C53F3F);
            }

            svg {
              position: absolute;
              bottom: 8px;
              right: 8px;
            }
          }
        }
      }
    }
  }
</style>

